import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as moment from 'moment';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { NfcRetailerStickersService } from '../../nfc-retailer-stickers.service';

class ActiveStickersFilter implements ng.IController {
    public static $inject = ['$scope', '$translate', '$uibModal', 'nfcRetailerStickersService', 'notificationService'];
    public onApply: (filter: any) => any;

    public model = {
        selectedLocations: [] as any[],
        selectedLocationsCount: 0 as number,
        isAllLocationsSelected: false as boolean,
        stickerType : null,
        dateFrom: null,
        dateTo: null
    };

    public dateOptions = {
        formatYear: 'yyyy',
        startingDay: 0
    };

    public stickerTypes: any = {
        0: this.$translate.instant('sticker_type_all'),
        1: this.$translate.instant('sticker_type_product'),
        2: this.$translate.instant('sticker_type_information_card'),
        3: this.$translate.instant('sticker_type_offer'),
        4: this.$translate.instant('sticker_type_checkin') + '/' + this.$translate.instant('sticker_type_checkout')
    };

    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        public nfcRetailerStickersService: NfcRetailerStickersService,
        public notificationService: NotificationService) {
    }

    public $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj
            && onChangesObj.filterModel.currentValue) {
            this.model.selectedLocations = onChangesObj.filterModel.currentValue.selectedLocations;
            this.model.selectedLocationsCount = onChangesObj.filterModel.currentValue.selectedLocations.length;
            this.model.dateFrom = onChangesObj.filterModel.currentValue.dateFrom;
            this.model.dateTo = onChangesObj.filterModel.currentValue.dateTo;
            this.model.stickerType = onChangesObj.filterModel.currentValue.type;
        }
    }

    public dateFromChange = () => {
        if (moment(this.model.dateFrom).isSameOrAfter(this.model.dateTo, 'day')) {
            this.model.dateTo =  moment(this.model.dateTo).endOf('day').toDate();
            this.model.dateFrom =  moment(this.model.dateTo).startOf('day').toDate();
        }
    }

    public dateToChange = () => {
        if (moment(this.model.dateTo).isSameOrBefore(this.model.dateFrom, 'day')) {
            this.model.dateTo =  moment(this.model.dateFrom).endOf('day').toDate();
            this.model.dateFrom =  moment(this.model.dateFrom).startOf('day').toDate();
        }
    }

    public onFilterApply = () => {
        this.onApply({filter: this.model});
    }

    public selectLocations = async () => {
        const operationResult: any = await this.$uibModal.open({
            component: 'selectLocations',
            resolve: { options: () => {
                    return {
                        selectedLocations: this.model.selectedLocations,
                        isAllSelected: this.model.isAllLocationsSelected
                    };
                } },
            size: 'md',
            backdrop: 'static',
        }).result;

        if (operationResult.status === 'ok') {
            if (operationResult.isAllSelected) {
                this.model.isAllLocationsSelected = true;
                this.nfcRetailerStickersService.getAllLocations()
                    .then((locations) => {
                        this.model.selectedLocationsCount = locations.length;
                        return this.model.selectedLocations = locations;
                    })
                    .catch((error) => this.notificationService.showErrorMessage(error));
            } else {
                this.model.isAllLocationsSelected = false;
                this.model.selectedLocations = operationResult.selectedLocations;
                this.model.selectedLocationsCount = this.model.selectedLocations.length;
            }
        }
    }

}

angular.module('naut').component('activeStickersFilter', {
    template: require('./active-stickers-filter.component.html'),
    controller: ActiveStickersFilter,
    controllerAs: 'ctrl',
    bindings: {
        filterModel: '<',
        onApply: '&',
        onAllClear: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/active-tab/active-stickers-filter/active-stickers-filter.component.ts